
const formatCurrency = (value) => {
    if (value === null || value === undefined || isNaN(parseFloat(value))) {
        return "0.00";
    }
    return parseFloat(value).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}
const AssociatedInsuranceInformation = ({data}) =>{
    return(
        <table className="min-w-full bg-white border border-gray-200">
            <thead>
                <tr className="bg-gray-100 border-none text-[#94A3B8]">
                    <th className="py-3 px-3 text-start text-base">Ref ID</th>
                    <th className="py-3 px-3 text-start text-base">Coverage Type</th>
                    <th className="py-3 px-3 text-start text-base">Quotation Type</th>
                    <th className="py-3 px-3 text-start text-base">Insurance Provider</th>
                    <th className="py-3 px-3 text-start text-base">Insurance Expiry</th>
                    <th className="py-3 px-3 text-start text-base">Finalised Sum Insured</th>
                </tr>
            </thead>
            <tbody>
                {data?.length > 0 ? (
                    data?.map((item, index) => (
                        <tr className="border-gray-200 border text-[#212121]" key={index}>
                            <td className="py-3 px-3 text-start text-base">{item.ref_id}</td>
                            <td className="py-3 px-3 text-start text-base">{item.coverage_type}</td>
                            <td className="py-3 px-3 text-start text-base">{item.quotation_type}</td>
                            <td className="py-3 px-3 text-start text-base">{item.insurance_provider}</td>
                            <td className="py-3 px-3 text-start text-base">{item.insurance_expiry}</td>
                            <td className="py-3 px-3 text-start text-base">MYR {formatCurrency(item.finalised_sum_insured)}</td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td className="py-3 px-3 text-start text-base">-</td>
                        <td className="py-3 px-3 text-start text-base">-</td>
                        <td className="py-3 px-3 text-start text-base">-</td>
                        <td className="py-3 px-3 text-start text-base">-</td>
                        <td className="py-3 px-3 text-start text-base">-</td>
                        <td className="py-3 px-3 text-start text-base">-</td>
                    </tr>
                )}
            </tbody>
        </table>
    )
}
const AssociatedFinancingInformation = ({data}) => {
    return(
        <table className="min-w-full bg-white border border-gray-200">
            <thead>
                <tr className="bg-gray-100 border-none text-[#94A3B8]">
                    <th className="py-3 px-3 text-start text-base w-[17%]">Financing Type</th>
                    <th className="py-3 px-3 text-start text-base w-[17%]">Financing Type (Other)</th>
                    <th className="py-3 px-3 text-start text-base w-[17%]">Partner</th>
                    <th className="py-3 px-3 text-start text-base w-[17%]">Partner (Other)</th>
                    <th className="py-3 px-3 text-start text-base w-[16%]">Approved Date</th>
                    <th className="py-3 px-3 text-start text-base w-[16%]">Approved Amount</th>
                </tr>
            </thead>
            <tbody>
                {data.length > 0 ? (
                    data.map((item, index) => (
                        <tr className="border-gray-200 border text-[#212121]" key={index}>
                            <th className="py-3 px-3 text-start text-base">{item.type}</th>
                            {item.type === 'Others' ? <th className="py-3 px-3 text-start text-base">{item.type_other}</th> : <th className="py-3 px-3 text-start text-base">-</th>}
                            <th className="py-3 px-3 text-start text-base">{item.partner}</th>
                            {item.partner === 'Others' ? <th className="py-3 px-3 text-start text-base">{item?.partner_other}</th> : <th className="py-3 px-3 text-start text-base">-</th>}
                            <th className="py-3 px-3 text-start text-base">{item.approved_at}</th>
                            <th className="py-3 px-3 text-start text-base">MYR {formatCurrency(item.approved_amt)}</th>
                        </tr>
                    ))
                ) : (
                    <tr className="border-gray-200 border text-[#212121]">
                        <th className="py-3 px-3 text-start text-base">-</th>
                        <th className="py-3 px-3 text-start text-base">-</th>
                        <th className="py-3 px-3 text-start text-base">-</th>
                        <th className="py-3 px-3 text-start text-base">-</th>
                        <th className="py-3 px-3 text-start text-base">-</th>
                        <th className="py-3 px-3 text-start text-base">-</th>
                    </tr>
                )}
            </tbody>
        </table>

    )
}
const AssociatedOpportunities = ({data}) =>{
    return(
        <table className="min-w-full bg-white border border-gray-200">
            <thead>
                <tr className="bg-gray-100 border-none text-[#94A3B8]">
                    <th className="py-3 px-3 text-start text-base w-[10%]">Opp ID</th>
                    <th className="py-3 px-3 text-start text-base w-[90%]">Title</th>
                </tr>
            </thead>
            <tbody>
                {data.length > 0 ? (
                    data.map((item, index) => (
                        <tr className="border-gray-200 border text-[#212121]" key={index}>
                            <th className="py-3 px-3 text-start text-base">{item.opp_id}</th>
                            <th className="py-3 px-3 text-start text-base">{item.title}</th>
                        </tr>
                    ))
                ) : (
                    <tr className="border-gray-200 border text-[#212121]">
                        <th className="py-3 px-3 text-start text-base">-</th>
                        <th className="py-3 px-3 text-start text-base">-</th>
                    </tr>
                )}
            </tbody>
        </table>
    )
}

export {AssociatedInsuranceInformation, AssociatedFinancingInformation, AssociatedOpportunities};
